//This is the functionality for the entrant
EMMY.payment = {
  init: function () {
    if (document.querySelector('.email-submit')) {
      var emailSubmit = document.querySelector('.email-submit');
      emailSubmit.addEventListener('click', function (e) {
        EMMY.entrants.breakVal = 'true';
        var formVal = $('#invoiceForm .form-control');
        EMMY.validateForm.checkRequired(formVal);
        if (!EMMY.entrants.breakVal) {
          e.preventDefault();
          // $('#invoiceForm').submit();
        }
      });
    }

    $(".void").on("submit", function(){
        return confirm("Do you want to delete this item?");
    });

    if(!iOS) {
      $('#creditCardForm select').on('select2:close', function(e) {

        if ($(this).attr('id') === 'country') {
          // Special case for the last dropdown.
          $('#creditCardForm button.btn-validate-checker').focus();
        }
        else {
          $(this).closest('.form-group').next().find('.form-control').focus();
        }

      });
    }

    $(document).on('click', '.table-checkbox input', function(e) {
      var numChecked = $('.paytable .table-checkbox input:checked').length;
      if(numChecked > 0) {
        $('.new-modal-trigger').show();
      } else {
        $('.new-modal-trigger').hide();
      }
    });

  }
};

